import _defineProperty from "/Users/alyssabutler/Documents/eisbach-riders/secondwavesurfing/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import * as React from 'react';
import clsx from 'clsx';
import { deepmerge } from '@material-ui/utils';
import { unstable_composeClasses as composeClasses } from '@material-ui/unstyled';
import useThemeProps from '../styles/useThemeProps';
import experimentalStyled from '../styles/experimentalStyled';
import cardActionAreaClasses, { getCardActionAreaUtilityClass } from './cardActionAreaClasses';
import ButtonBase from '../ButtonBase';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var overridesResolver = function overridesResolver(props, styles) {
  return deepmerge(_defineProperty({}, "& .".concat(cardActionAreaClasses.focusHighlight), styles.focusHighlight), styles.root || {});
};

var useUtilityClasses = function useUtilityClasses(styleProps) {
  var classes = styleProps.classes;
  var slots = {
    root: ['root'],
    focusHighlight: ['focusHighlight']
  };
  return composeClasses(slots, getCardActionAreaUtilityClass, classes);
};

var CardActionAreaRoot = experimentalStyled(ButtonBase, {}, {
  name: 'MuiCardActionArea',
  slot: 'Root',
  overridesResolver: overridesResolver
})(function (_ref) {
  var _ref2;

  var theme = _ref.theme;
  return _ref2 = {
    /* Styles applied to the root element. */
    display: 'block',
    textAlign: 'inherit',
    width: '100%'
  }, _defineProperty(_ref2, "&:hover .".concat(cardActionAreaClasses.focusHighlight), {
    opacity: theme.palette.action.hoverOpacity,
    '@media (hover: none)': {
      opacity: 0
    }
  }), _defineProperty(_ref2, "&.Mui-focusVisible .".concat(cardActionAreaClasses.focusHighlight), {
    opacity: theme.palette.action.focusOpacity
  }), _ref2;
});
var CardActionAreaFocusHighlight = experimentalStyled('span', {}, {
  name: 'MuiCardActionArea',
  slot: 'FocusHighlight'
})(function (_ref3) {
  var theme = _ref3.theme;
  return {
    /* Styles applied to the overlay that covers the action area when it is keyboard focused. */
    overflow: 'hidden',
    pointerEvents: 'none',
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    borderRadius: 'inherit',
    opacity: 0,
    backgroundColor: 'currentcolor',
    transition: theme.transitions.create('opacity', {
      duration: theme.transitions.duration.short
    })
  };
});
var CardActionArea = /*#__PURE__*/React.forwardRef(function CardActionArea(inProps, ref) {
  var props = useThemeProps({
    props: inProps,
    name: 'MuiCardActionArea'
  });

  var children = props.children,
      className = props.className,
      focusVisibleClassName = props.focusVisibleClassName,
      other = _objectWithoutPropertiesLoose(props, ["children", "className", "focusVisibleClassName"]); // TODO: convert to simple assignment after the type error in defaultPropsHandler.js:60:6 is fixed


  var styleProps = _extends({}, props);

  var classes = useUtilityClasses(styleProps);
  return /*#__PURE__*/_jsxs(CardActionAreaRoot, _extends({
    className: clsx(classes.root, className),
    focusVisibleClassName: clsx(focusVisibleClassName, classes.focusVisible),
    ref: ref,
    styleProps: styleProps
  }, other, {
    children: [children, /*#__PURE__*/_jsx(CardActionAreaFocusHighlight, {
      className: classes.focusHighlight,
      styleProps: styleProps
    })]
  }));
});
process.env.NODE_ENV !== "production" ? void 0 : void 0;
export default CardActionArea;